import { Store } from "../core"

export const selectEntryPath = (state: Store) => state.common.protectedEntryPath
